// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Strip heavy base64 blobs from persisted state (localStorage has ~5MB limit)
const stripImages = createTransform(
  (inbound) => ({
    ...inbound,
    images: [],
    techImages: [],
    coverImages: [],
    extractedResumeText: null,
  }),
  (outbound) => outbound,
  { whitelist: ["reducer"] }
);

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["reducer"],
  transforms: [stripImages],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({ serializableCheck: false }),
});

export const persistor = persistStore(store);
export default store;